import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const CustomSkeleton = ({ count, ...rest }) => {
  !count && (count = 1);
  let skelet = [];
  for (let i = 0; i < count; i++) {
    skelet.push(<Skeleton key={i} {...rest} variant="text" animation="wave" />);
  }
  return skelet;
};
export default CustomSkeleton;
